import { UI_STYLES } from "@/styles/uiStyles";
import { PrognosisDomain } from "@/types/Prognosis";
import { PrognoseTopBar } from "@/components/ui/PrognoseTopBar";
import { ZodiacDomain } from "@/types/Zodiac";

interface ZodiacPrognosisPremiumProps {
  zodiac: ZodiacDomain | null;
  isPrognosisForYear: boolean;
  selectPrognosisForYear: () => void;
  prognoses: PrognosisDomain[];
  selectedPrognose: PrognosisDomain | null;
  selectPrognosis: (prognose: PrognosisDomain) => void;
  paddingBottom: number;
}

export const ZodiacPrognosisPremium = ({
  zodiac,
  prognoses,
  selectedPrognose,
  selectPrognosis,
  isPrognosisForYear,
  selectPrognosisForYear,
  paddingBottom,
}: ZodiacPrognosisPremiumProps) => {

  return (
    <div className={`flex flex-col items-center w-full mx-auto h-full`}
    style={{
      paddingBottom: `max(calc(env(safe-area-inset-bottom, 0px)), ${paddingBottom}px)`,
    }}
    >
      <div className="px-4 mb-2 max-w-xl w-full ">
        <div className={`flex flex-row items-end gap-2 justify-start w-full `}>
          <img
            onClick={selectPrognosisForYear}
            src={zodiac?.image}
            alt={zodiac?.name}
            className={`w-14 h-11 object-contain ${
              isPrognosisForYear
                ? UI_STYLES.bgEmerald 
                : UI_STYLES.buttonGradient
            } rounded-lg`}
          />
          <PrognoseTopBar
            prognoses={prognoses}
            selectedPrognose={selectedPrognose}
            selectPrognosis={selectPrognosis}
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center  w-full max-w-xl mx-auto w-full min-h-[700px] overflow-y-auto text-white text-sm leading-relaxed text-center  hide-scrollbar ">
        <div
          className={`w-full ${UI_STYLES.bgDarkBlue4} rounded-2xl p-4 text-white text-sm leading-relaxed text-justify mb-[300px]`}
        >
          {selectedPrognose?.text}
        </div>
      </div>
    </div>
  );
};
